// Globální axios interceptory — přidávají API klíč a JWT token ke každému požadavku.
// Importováno jednou v index.js, platí pro celou aplikaci.
import axios from 'axios';
import { getStoredToken } from './auth';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const CONFIG_URL = `${API_BASE}/config`;

// API klíč se nebuilduje do bundlu (viz backend GET /api/config), aby se nikdy
// nerozjel s hodnotou API_SECRET_KEY nastavenou na App Service. Promise je
// memoizovaná, takže se o klíč requestne jen jednou i při souběžných voláních.
let apiKeyPromise = null;

function nactiApiKey() {
    if (!apiKeyPromise) {
        apiKeyPromise = axios.get(CONFIG_URL)
            .then(res => res.data.apiKey || '')
            .catch(() => '');
    }
    return apiKeyPromise;
}

axios.interceptors.request.use(async config => {
    if (config.url !== CONFIG_URL) {
        const apiKey = await nactiApiKey();
        if (apiKey) config.headers['X-API-Key'] = apiKey;
    }

    const token = getStoredToken();
    if (token) config.headers['Authorization'] = `Bearer ${token}`;

    return config;
});
